export default "__VITE_ASSET__XhxqrGHP__"